'use client';

import type { SearchSidebarProps } from '../types';
import RecentSearches from './RecentSearches';
import TopSearches from './TopSearches';

export default function SearchSidebar({
  recentSearches,
  topSearches,
  onSearchClick,
  onRemoveRecent,
}: SearchSidebarProps) {
  return (
    <div className="flex flex-col items-start w-[330px] h-full overflow-y-auto custom-scrollbar bg-[#F8F8F8] pt-6 pr-9 pb-6 pl-6">
      <RecentSearches
        searches={recentSearches}
        onSearchClick={onSearchClick}
        onRemove={onRemoveRecent}
      />
      <TopSearches searches={topSearches} onSearchClick={onSearchClick} />
    </div>
  );
}
